module.exports = __webpack_public_path__ + "images/aegon_small70f69bff74af0669651ca09d109aa63d.png";